// extracted by mini-css-extract-plugin
module.exports = {"Controls":"Controls_Controls__3V2vr","ButtonRow":"Controls_ButtonRow__25FFq","Label":"Controls_Label__3BQ6s","ScrollContainer":"Controls_ScrollContainer__2t2Hs"};